import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_AdminDashboard_PlanSummary,
} from '../../services/wealthlane-award-services';

const useGetDashboardPlanSummary = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<Wealthlane_AwardService_Dtos_AdminDashboard_PlanSummary> | undefined,
  unknown
> => {
  const dashboardPlanSummary = useQuery(['getDashboardPlanSummary'], async () => {
    return await handleRequest(DashboardService.getApiAwardApiAppDashboardPlanSummary());
  });

  return dashboardPlanSummary;
};

export default useGetDashboardPlanSummary;
